import "./style.css";
import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  INDUSTRY,
  SCHOOL,
  TEACHER,
  VISITOR,
  ADMIN,
  HELPDESK,
  VOLUNTEER,
  FACULTY,
} from "../../utils/constants";
import { AxisOptions, Chart } from "react-charts";
import { getAllUsersOneTime, getAllVisits } from "../../utils/firebase-config";
import DashboardCard from "../../components/dashboard_card";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import BarCharts from "../../components/bar_charts";
import DashboardCardPresenter from "../../components/dashboard_card_presenter";

export default function DashboardPage() {
  const navigation = useNavigate();
  const location = useLocation();
  const [currentUser, setUser] = useState(null);
  const [expandedIndex, setExpandedIndex] = useState(-1);
  const [allUsers, setAllUsers] = useState([]);
  const [visitor, setVisitor] = useState([]);
  const [visitorChartData, setVisitorChartData] = useState([]);
  const [demoPresenterChartData, setDemoPresenterChartData] = useState({});

  useEffect(() => {
    if (location.state === null) {
      navigation("/");
    } else {
      if (location.state.type === ADMIN) {
        setUser(location.state);
      } else {
        navigation("/");
      }
    }
  }, []);

  useEffect(() => {
    getAllUsersOneTime().then((data) => {
      setAllUsers(data);
    });
  }, [currentUser]);

  useEffect(() => {
    const filterUser = allUsers.filter(
      (user) =>
        user.type === SCHOOL ||
        user.type === TEACHER ||
        user.type === INDUSTRY ||
        user.type === VISITOR
    );
    setVisitor(filterUser);
  }, [allUsers]);

  useEffect(() => {
    if (visitor.length > 0 && allUsers.length > 0) {
      getAllVisits((data) => {
        //Visitor Data
        let tempList = [];
        let v = data.map((visit) => {
          const filterVisitor = visitor.filter(
            (visitorData) => visitorData.email === visit.email
          );

          const filterPresenter = allUsers.filter(
            (user) => user.email === visit.presenter_email
          );

          return {
            time: visit.time,
            visitor: filterVisitor.length > 0 ? filterVisitor[0] : {},
            presenter: filterPresenter.length > 0 ? filterPresenter[0] : {},
          };
        });
        const transformedData = {};

        v.forEach((item) => {
          const email = item.visitor.email;
          if (!transformedData[email]) {
            transformedData[email] = [];
          }
          transformedData[email].push(item);
        });

        console.log(transformedData);
        Object.keys(transformedData).forEach((element) => {
          tempList.push({
            count: transformedData[element].length,
            visitor: transformedData[element][0].visitor,
          });
        });

        tempList = tempList.sort(function (x, y) {
          if (x.count < y.count) {
            return 1;
          }
          if (x.count > y.count) {
            return -1;
          }
          return 0;
        });
        setVisitorChartData(tempList);

        //Presenter Data
        let tempListPresenter = [];
        let vPresenter = data.map((visit) => {
          const filterVisitor = visitor.filter(
            (visitorData) => visitorData.email === visit.email
          );

          const filterPresenter = allUsers.filter(
            (user) => user.email === visit.presenter_email
          );

          return {
            time: visit.time,
            visitor: filterVisitor.length > 0 ? filterVisitor[0] : {},
            presenter: filterPresenter.length > 0 ? filterPresenter[0] : {},
          };
        });
        const transformedDataPresenter = {};

        vPresenter.forEach((item) => {
          const email = item.presenter.email;
          if (!transformedDataPresenter[email]) {
            transformedDataPresenter[email] = [];
          }
          transformedDataPresenter[email].push(item);
        });

        console.log(transformedDataPresenter);
        Object.keys(transformedDataPresenter).forEach((element) => {
          tempListPresenter.push({
            count: transformedDataPresenter[element].length,
            presenter: transformedDataPresenter[element][0].presenter,
          });
        });

        tempListPresenter = tempListPresenter.sort(function (x, y) {
          if (x.count < y.count) {
            return 1;
          }
          if (x.count > y.count) {
            return -1;
          }
          return 0;
        });
        setDemoPresenterChartData(tempListPresenter);
      });
    }
  }, [visitor, allUsers]);

  return (
    <div className="form-div-full-admin">
      {currentUser !== null && (
        <div
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          <div className="title-admin">
            <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
              <p
                className="link-admin"
                onClick={() => {
                  navigation(-1);
                }}
              >
                Go Back
              </p>
            </div>
            <h1>Dashboard</h1>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <p style={{ display: "none" }}>{`Go Back`}</p>
            </div>
          </div>
          <div>
            <DashboardCard
              title="Visitors Visits"
              description="View Charts and most visits"
              list={visitorChartData}
              expanded={expandedIndex === 1}
              onClick={() => {
                if (expandedIndex === 1) {
                  setExpandedIndex(-1);
                } else {
                  setExpandedIndex(1);
                }
              }}
            />
            <DashboardCardPresenter
              title="Lab Presenters"
              description="View Charts and most presents"
              list={demoPresenterChartData}
              expanded={expandedIndex === 2}
              onClick={() => {
                if (expandedIndex === 2) {
                  setExpandedIndex(-1);
                } else {
                  setExpandedIndex(2);
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
